import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconWalletOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M0 22.06V2h21.36v1.593H1.593v16.874h20.814V6.697H6.017V5.09H24v16.97zm16.123-8.9a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0" /></svg>
);
